"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayClassName = _ref.overlayClassName,
      onRequestClose = _ref.onRequestClose,
      closeElement = _ref.closeElement,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "overlayClassName", "onRequestClose", "closeElement", "children"]);

  var finalClassName = className || {
    base: 'Modal',
    afterOpen: "Modal-after-open",
    beforeClose: "Modal-before-close"
  };
  var finalOverlayClassName = overlayClassName || {
    base: 'Mask',
    afterOpen: "Mask-after-open",
    beforeClose: "Mask-before-close"
  };

  if (closeElement === undefined) {
    closeElement = 'close';
  }

  return React.createElement(_reactModal.default, _extends({}, props, {
    className: finalClassName,
    overlayClassName: finalOverlayClassName,
    onRequestClose: onRequestClose
  }), onRequestClose && closeElement && React.createElement("a", {
    onClick: onRequestClose,
    className: "modal-close"
  }, closeElement), children);
};

var _default = Modal;
exports.default = _default;